<!-- 用户详情 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title">
        <span>基本信息</span>
      </div>
      <div class="model-content">
        <table class="public-table jbxx-table" v-if="userInfo!={}">
          <tr>
            <td class="td-head">公司名称</td>
            <td>{{userInfo.comName?userInfo.comName:'-'}}</td>
            <td class="td-head">公司简称</td>
            <td>{{userInfo.comBriefName?userInfo.comBriefName:'-'}}</td>
            <td class="td-head">公司类型</td>
            <td>{{$common.toStr(userInfo.comType,dictionary.com_type)}}</td>
            <td class="td-head">用户类型</td>
            <td><span v-if="userInfo.roleList">{{$common.toStr(userInfo.roleList[0].id,dictionary.user_type)}}</span></td>
          </tr>
          <tr>
            <td class="td-head">联系人</td>
            <td>{{userInfo.userName?userInfo.userName:'-'}}</td>
            <td class="td-head">联系电话</td>
            <td>{{userInfo.userPhone?userInfo.userPhone:'-'}}</td>
            <td class="td-head">默认密码</td>
            <td>{{userInfo.userPassword?userInfo.userPassword:'-'}}</td>
            <td class="td-head">IP</td>
            <td>{{userInfo.accessIP?userInfo.accessIP:'-'}}</td>
          </tr>
          <tr>
            <td class="td-head">当前状态</td>
            <td>{{$common.toStr(userInfo.userStatus,dictionary.user_status)}}</td>
            <td class="td-head">渠道名</td>
            <td>{{userInfo.channelName?userInfo.channelName:'-'}}</td>
            <td class="td-head">应付总金额（元）</td>
            <td v-if="userInfo.shouldPayAmountTotal || userInfo.shouldPayAmountTotal==0">{{userInfo.shouldPayAmountTotal}}</td>
            <td v-if="!userInfo.shouldPayAmountTotal && userInfo.shouldPayAmountTotal!=0">-</td>
            <td class="td-head">已付总额（元）</td>
            <td v-if="userInfo.alreadyPayAmountTotal || userInfo.alreadyPayAmountTotal==0">{{userInfo.alreadyPayAmountTotal}}</td>
            <td v-if="!userInfo.alreadyPayAmountTotal && userInfo.alreadyPayAmountTotal!=0">-</td>
          </tr>
          <tr>
            <td class="td-head">待付金额（元）</td>
            <td v-if="userInfo.waitPayAmount || userInfo.waitPayAmount==0">{{userInfo.waitPayAmount}}</td>
            <td v-if="!userInfo.waitPayAmount && userInfo.waitPayAmount!=0">-</td>
            <td class="td-head">上线期间</td>
            <td v-if="userInfo.startTime">{{userInfo.startTime}} 至 {{userInfo.endTime}}</td>
            <td v-if="!userInfo.startTime">-</td>
            <td class="td-head">上线剩余天数</td>
            <td v-if="userInfo.onLineRemainDays || userInfo.onLineRemainDays==0">{{userInfo.onLineRemainDays}}</td>
            <td v-if="!userInfo.onLineRemainDays && userInfo.onLineRemainDays!=0">-</td>
            <td class="td-head">已使用上线数量</td>
            <td v-if="userInfo.usedOnLineTotal || userInfo.usedOnLineTotal==0">{{userInfo.usedOnLineTotal}}</td>
            <td v-if="!userInfo.usedOnLineTotal && userInfo.usedOnLineTotal!=0">-</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="model-box">
      <!-- <div class="model-title">
        <span>测试接口配置</span>
      </div> -->
      <div class="model-content model-content-noPadding">
        <el-tabs class="tab-first" v-model="activePage" @tab-click="handleClick">
          <el-tab-pane  label="测试信息" name="testInfo">
            <span class="model-content-title model-content-title-top">时间设置</span>
            <table v-if="activePage=='testInfo'" class="public-table jbxx-table">
              <tr>
                <td class="td-head">测试时间段</td>
                <td v-if="userInfo.testTerm">{{$common.toStr(userInfo.testTerm,dictionary.term_type)}}</td>
                <td v-if="!userInfo.testTerm">-</td>
                <td class="td-head">测试起始时间</td>
                <td>{{userInfo.testStartTime?userInfo.testStartTime:'-'}}</td>
                <td class="td-head">测试结束时间</td>
                <td>{{userInfo.testEndTime?userInfo.testEndTime:'-'}}</td>
              </tr>
              <tr>
                <td class="td-head">测试剩余天数</td>
                <td v-if="userInfo.testRemainDays || userInfo.testRemainDays==0">{{userInfo.testRemainDays}}</td>
                <td v-if="!userInfo.testRemainDays && userInfo.testRemainDays!=0">-</td>
                <td class="td-head">已使用测试数量</td>
                <td v-if="userInfo.usedTestTotal || userInfo.usedTestTotal==0">{{userInfo.usedTestTotal}}</td>
                <td v-if="!userInfo.usedTestTotal && userInfo.usedTestTotal!=0">-</td>
                <td class="td-head"></td>
                <td></td>
              </tr>
            </table>
            <span class="model-content-title">接口设置</span>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item,index) in ApiList" :key="index" :label="item.interDesc" :name="item.interId">
                <el-table
                  v-if="activeName==item.interId"
                  ref="multipleTable"
                  :data="item.items"
                  border
                  header-row-class-name="tableHead"
                  class="no-edit-table"
                  style="width: 800px">
                  <el-table-column
                    type="selection"
                    align="center"
                    :selectable='selectInit'
                    width="50">
                  </el-table-column>
                  <el-table-column
                    prop="interDesc"
                    label="接口名称"
                    min-width="56%">
                  </el-table-column>
                  <el-table-column
                    label="测试调用数量"
                    prop="interfaceTestTotal"
                    min-width="44%">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane label="权限信息" name="permissionsInfo">
            <el-table
              v-if="activePage=='permissionsInfo'"
              :data="permissionsData"
              border
              header-row-class-name="tableHead"
              style="width: 70%">
              <el-table-column
              type="index"
              align="center"
              label="序号"
              width="70">
              </el-table-column>
              <el-table-column
              label="签约时间"
              prop="createTime"
              min-width="30%">
              </el-table-column>
              <el-table-column
              label="签约类型"
              min-width="20%">
                <template slot-scope="scope">
                  {{$common.toStr(scope.row.signType,dictionary.user_status)}}
                </template>
              </el-table-column>
              <el-table-column
              label="签约期限"
              min-width="20%">
                <template slot-scope="scope">
                  {{$common.toStr(scope.row.signTerm,dictionary.term_type)}}
                </template>
              </el-table-column>
              <el-table-column
              label="上线期限"
              min-width="30%">
              <template slot-scope="scope">
                  <span>{{scope.row.startDate}} 至 {{scope.row.endDate}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="账单信息" name="accountFlow">
            <el-table
              v-if="activePage=='accountFlow'"
              :data="accountFlowData"
              border
              header-row-class-name="tableHead"
              style="width: 70%">
              <el-table-column
              label="账单期限"
              min-width="25%">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.startTime">{{scope.row.startTime}}</span>
                    <span v-if="scope.row.startTime"> - </span>
                    <span v-if="scope.row.endTime">{{scope.row.endTime}}</span>
                    <span v-if="!scope.row.endTime">至今</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
              label="账单金额"
              prop="billAmount"
              min-width="15%">
              </el-table-column>
              <el-table-column
              label="账单状态"
              prop="billStatus"
              min-width="15%">
              </el-table-column>
              <el-table-column
              label="应结算日期"
              prop="shouldSettleTime"
              min-width="15%">
              </el-table-column>
              <el-table-column
              label="结算状态"
              min-width="15%">
                <template slot-scope="scope">
                  <span v-if="scope.row.settleStatus==0">未结算</span>
                  <span v-if="scope.row.settleStatus==1">已结算</span>
                </template>
              </el-table-column>
              <el-table-column
              label="实际结算时间"
              prop="realSettleTime"
              min-width="15%">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetailAfterpay',
  data () {
    return {
      userId:this.$route.query.id,
      userInfo:{},
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      activePage:'testInfo',
      activeName: '',
      ApiList:[],
      permissionsData:[],
      accountFlowData:[],
      multipleSelectionAll: {},   // 所有选中的数据包含跨页数据
      multipleSelection: [],   // 当前页选中的数据
    }
  },
  mounted () {
    var _this=this;
    _this.editInfoDataFun(1);
    _this.editInfoDataFun(5);
    _this.editInfoDataFun(3);
    _this.editInfoDataFun(4);
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      // console.log(tab, event);
      _this.$nextTick(() => {
        var tabData=[];
        _this.ApiList.forEach(function(dataItem){
          if(dataItem.interId==_this.activeName){
            tabData=dataItem.items;
          };
        })
        if(_this.multipleSelectionAll[_this.activeName]){
          _this.multipleSelectionAll[_this.activeName].forEach(function(item){
            tabData.forEach(function(dataItem){
              if (item.interId == dataItem.interId) {
                _this.$refs.multipleTable[0].toggleRowSelection(dataItem, true)
              }
            })
          })
        };
      });
    },
    // 查看用户信息
    editInfoDataFun:function(type){
      var _this=this;
      var sendData=new Object();
      sendData.type=type;
      sendData.userId=_this.userId;
      _this.$axios.post("/requestApi/manage/find/user/information",sendData)     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){   
            if(type==1){
              _this.userInfo=data.data;
            }else if(type==5){
              _this.ApiList=[];
              data.data.forEach(function(item){
                var itemObj=new Object();
                itemObj.interId=item.interId;
                itemObj.interDesc=item.interDesc;
                itemObj.items=[];
                item.items.forEach(function(itemChild){
                  if(itemChild.interUrl!=null){
                    itemObj.items.push(itemChild)
                  };
                });
                _this.ApiList.push(itemObj);
              });
              _this.ApiList.forEach(function(item){
                _this.multipleSelectionAll[item.interId]=[];
                item.items.forEach(function(itemChild){
                  if(itemChild.interfaceTestTotal==null){
                    itemChild.interfaceTestTotal=0;
                  };
                  if(itemChild.isBinding==1){
                    _this.multipleSelectionAll[item.interId].push(itemChild);
                  };
                });
              });
              _this.handleClick();
              _this.activeName=_this.ApiList[0].interId;
            }else if(type==3){
              _this.permissionsData=data.data;
            }else if(type==4){
              // console.log("1================="+JSON.stringify(data));
              _this.accountFlowData=data.data.accountFlowList;
              data.data.accountFlowTotal.endTime="合计";
              _this.accountFlowData.push(data.data.accountFlowTotal);
            };
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    selectInit(row,index){
      return false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 15%;}
.jbxx-table tr .td-head{width: 10%;}
.model-content-title-top{margin-top: 0px;}
// .public-table tr td{width: 23.3333%;}
// .public-table tr .td-head{width: 10%;}

</style>



// WEBPACK FOOTER //
// src/components/UserDetailAfterpay.vue